import ActiveController from "rapid/controller";

export class selectSearchController extends ActiveController {
	constructor($injector, $rootScope, $element) {
		"ngInject";
		super($injector);

		this.$rootScope = $rootScope;
		this.$element = angular.element($element);
		this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
	}

	$onInit() {
		this.$element.find("input").on("keydown", function(ev) {
            ev.stopPropagation();
        });
	}

	searchFilter(query) {
		try {
            let re = new RegExp(query, "gi");
            return (item) => item[item.name ? "name" : "booth_id"].match(re);
        } catch(e) {
			return;
		}
	}

	clearSearchTerm() {
		this.searchTerm = "";
	}

	change(model) {
		this.onValueChange({value: model});
	}

}



// WEBPACK FOOTER //
// ./sources/components/common/select-search/select-search.controller.js